import React from 'react';
import Navbar from '../../Components/Navbar';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

// import required modules
import { FreeMode, Pagination } from 'swiper/modules';



const bibliothequePage = (props) => {

    const openGuide = () => {
        const pdfUrl = '/images/biblio/guideDuMarines.pdf';
        window.open(pdfUrl, '_blank');
    };

    const openPrepaTraining = () => {
        const pdfUrl = '/images/biblio/FLOTTE_KEYBINDS_3.23x.pdf';
        window.open(pdfUrl, '_blank');
    };

    const openFicheReflex1 = () => {
        const pdfUrl = '/images/biblio/ARTILLEUR_KEYBINDS_3.23x.pdf';
        window.open(pdfUrl, '_blank');
    };


    return (
        <div className='bibliothequePage'>
            <Navbar />
            <div className='bibliotheque'>
                <>
                    <div className='bibliotheque__biblioText'>
                        <h2>Bibliothèque</h2>
                        <p>Sauf exception, les documents ci-dessous sont créés et publiés par les membres de la corpo pour permettre à l'ensemble de progresser. Dans un souci de confidentialité, veuillez limiter leur diffusion. Merci.</p>
                    </div>
                    <div className='bibliotheque__swipCont'>

                        <Swiper
                            slidesPerView={3}
                            spaceBetween={30}
                            freeMode={true}

                            modules={[FreeMode, Pagination]}
                            className="mySwiper"
                        >
                            {/* <SwiperSlide className='prepaTraining' onClick={openPrepaTraining} ></SwiperSlide>
                            <SwiperSlide className='ficheReflex1' onClick={openFicheReflex1}></SwiperSlide> */}
                            <SwiperSlide className='guideDuMarine' onClick={openGuide}></SwiperSlide>
                        </Swiper>

                    </div>





                </>
            </div>
        </div>

    );
};

export default bibliothequePage;